<template>
  <v-container>
    <h1>EIE Investments</h1>
    <EieInvestmentsTable
      v-if="eieInvestments"
      :eie-investments="eieInvestments"
      :loading="loading"
      :cancel-investment="cancelInvestment"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { EieInvestmentsTable } from '@/components/eie';

export default {
  name: 'EieInvestments',
  components: {
    EieInvestmentsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.eieInvestmentsStore.loading,
      eieInvestments: state => state.eieInvestmentsStore.eieInvestments,
    }),
  },
  methods: {
    ...mapActions(['cancelInvestment']),
  },
};
</script>


<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/eie/EieInvestments.vue